export const TOGGLE_CHECKBOX_BY_KEY = '@backup/toggle-checkbox-by-key';
export const SET_STATUS = '@backup/set-status';
export const SET_ERROR = '@backup/set-error';
export const RESET_REDUCER = '@backup/reset-reducer';
